export default __webpack_public_path__ + "static/media/aboutus_mission_vision.9837d349.png";